import React, { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDataLayer } from 'hooks/useDataLayer';
import { Icon, Flex, Text, Box } from 'roo-ui/components';
import { getIsAuthenticated } from 'store/user/userSelectors';
import { getQffAuth } from 'lib/qffAuth';
import { AuthButton, QffMenuWrapper } from './primitives';
import AuthenticationDetails from './AuthenticationDetails';
import QffMenuContent from 'components/QffMenu/QffMenuContent';

const login = async () => {
  try {
    const qffAuth = await getQffAuth();
    qffAuth.showLoginModal();
  } catch (e) {
    //do nothing yet
  }
};

const AuthBtnOpen = () => (
  <Flex flexDirection="column" alignItems="center">
    <Icon name="close" data-testid="close-icon" />
    <Text data-testid="close-text">Close</Text>
  </Flex>
);

const AuthBtnClosed = () => (
  <Fragment>
    <Icon name="person" data-testid="person-icon" />
    <AuthenticationDetails />
  </Fragment>
);

const AuthenticationButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { emitInteractionEvent } = useDataLayer();

  const isAuthenticated = useSelector(getIsAuthenticated);

  const handleOnClick = useCallback(() => {
    login();
    setIsOpen(false);
    emitInteractionEvent({ type: 'QFF Login Button', value: 'Desktop Log In Button Selected' });
  }, [emitInteractionEvent]);

  const toggleQffMenu = useCallback(() => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);

    emitInteractionEvent({ type: 'QFF Login Dropdown', value: `Desktop Dropdown ${newIsOpen ? 'Expanded' : 'Collapsed'}` });
  }, [emitInteractionEvent, isOpen]);

  return (
    <Box>
      {!isAuthenticated && (
        <AuthButton onClick={handleOnClick} data-testid="login-button">
          Log in
        </AuthButton>
      )}
      {isAuthenticated && (
        <AuthButton onClick={toggleQffMenu} isAuthenticated isOpen={isOpen} data-testid="toggle-button">
          {isOpen && <AuthBtnOpen />}
          {!isOpen && <AuthBtnClosed />}
        </AuthButton>
      )}

      {isAuthenticated && isOpen && (
        <QffMenuWrapper>
          <QffMenuContent onLogout={() => setIsOpen(false)} />
        </QffMenuWrapper>
      )}
    </Box>
  );
};

export default AuthenticationButton;
